/**
 * v-loading directive plugin
 * Adds a loading state to buttons with spinner and disabled state
 *
 * Usage: <button v-loading="isLoading">Click me</button>
 */

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('loading', {
    mounted(el: HTMLElement, binding) {
      updateLoadingState(el, binding.value)
    },
    updated(el: HTMLElement, binding) {
      updateLoadingState(el, binding.value)
    },
  })
})

function updateLoadingState(el: HTMLElement, isLoading: boolean) {
  const button = el.tagName === 'BUTTON' ? el : el.querySelector('button')

  if (!button) {
    return
  }

  // Store original content if not already stored
  if (!button.dataset.originalContent) {
    button.dataset.originalContent = button.innerHTML
  }

  if (isLoading) {
    // Add loading class for styling
    button.classList.add('is-loading')

    // Create spinner HTML
    const spinner = `
      <svg class="animate-spin -ml-1 mr-2 h-4 w-4 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `

    // Store the original content and replace with spinner + text
    const originalText = button.textContent?.trim() || ''
    button.innerHTML = `<span class="mr-2">${originalText}</span> ${spinner}`
  } else {
    // Remove loading class
    button.classList.remove('is-loading')

    // Restore original content
    if (button.dataset.originalContent) {
      button.innerHTML = button.dataset.originalContent
    }
  }
}
